module.exports = __webpack_public_path__ + "static/media/profile-about-2.b3f2ff86.jpg";